module.exports = __webpack_public_path__ + "media/images/home/sc4-b8542ca22343890bd8788ad8bac7c176.webp";